import { render } from "./Confirmation.vue?vue&type=template&id=51bfb5e2&scoped=true&ts=true"
import script from "./Confirmation.vue?vue&type=script&lang=ts"
export * from "./Confirmation.vue?vue&type=script&lang=ts"

import "./Confirmation.vue?vue&type=style&index=0&id=51bfb5e2&scoped=true&lang=scss"

import exportComponent from "/buddy/openbanking/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51bfb5e2"]])

export default __exports__